import axios from 'axios';
import { getApiV1Url } from '../utils/api';

export interface SuggestPlaceParams {
  size?: number,
}

export enum PlaceType {
  PROVINCE = 'PROVINCE',
  LOCALITY = 'LOCALITY',
  AREA = 'AREA',
}

export interface Place {
  type: PlaceType,
  id?: string,
  name: string,
  slug: string,
  parent?: Place,
}

export interface SuggestPlaceResponse {
  highlightedSuggestion: string,
  place: Place,
}

export async function suggestPlace(query: string, params: SuggestPlaceParams = {}): Promise<Array<SuggestPlaceResponse>> {
  const { data } = await axios.get<SuggestPlaceResponse[]>(`${getApiV1Url()}/place/suggest/${query}`, { params });
  return data;
}
